import axios from '../utils/axios';

/**
 * Get job logs
 * @param {string} adminId - Admin ID
 * @param {string} jobName - Job name
 * @param {Object} params - Query parameters (year, month, day)
 * @returns {Promise} API response
 */
export default function fetchCronJobLogs(adminId, jobName, params = {}) {
    return axios.get(`/admin/${adminId}/cron/jobs/${jobName}/logs`, { params });
}
